'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  users: {
    accessRights: {
      calendars: 'Calendars',
      hideInheritedRights: 'Hide the inherited rights',
      organizations: 'Organizations',
      showInheritedRights: 'Show the inherited rights',
      title: 'Access rights'
    },
    attributes: {
      email: 'Email',
      password: 'Password'
    },
    empty: 'No user found.',
    form: {
      confirmSave: 'Do you want to save the changes made to this user\xA0?',
      dontSave: 'Do not save'
    },
    invite: {
      button: 'Invite a user',
      messagePlaceholder: 'Optional message',
      save: 'Invite',
      text: 'The user will be invited on'
    },
    next: 'Next page',
    new: 'Add new user',
    previous: 'Previous page',
    sortDirection: {
      asc: 'ascending',
      desc: 'descending'
    },
    sortOrder: {
      creation: 'creation date',
      email: 'email',
      modification: 'modification',
      name: 'name'
    },
    title: 'Users',
    titleBox: {
      help: 'User name'
    },
    total: '%{smart_count} user ordered by |||| %{smart_count} users ordered by'
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/users.js
// module id = 2288
// module chunks = 0